<template>
  <div class="mh-movies-area ptb-100">
    <div class="container-fluid">
      <div class="mh-movies-title">
        <h5 class="text-white">أبرز الباقات والمحتوى المتوفر اليوم</h5>
      </div>

      <Swiper
        :slidesPerView="1"
        :loop="true"
        :centeredSlides="true"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
        }"
        :pagination="{
          el: '.mh-movies-pagination',
          clickable: true,
        }"
        :breakpoints="{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 5 },
          1200: { slidesPerView: 5 },
        }"
        :modules="modules"
        class="mh-movies-slider"
      >
        <SwiperSlide v-for="(movie, index) in movies" :key="index">
          <div class="mh-movies-card">
            <div class="image">
              <img :src="movie.image" :alt="movie.title" />
              <div class="number">{{ index + 1 }}</div>
            </div>
            <div class="content">
              <h3>{{ movie.title }}</h3>
              <a href="https://wa.me/447429916178" target="_blank" class="link-btn">
                تفاصيل الباقة
                <i class="ti ti-arrow-left"></i>
              </a>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <div class="mh-movies-pagination"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination } from "swiper/modules";

export default defineComponent({
  name: "TopMoviesToday",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const movies = ref([
      {
        title: "باقة قنوات BEIN SPORTS كاملة",
        image: require("@/assets/images/movie-home/movie1.jpg"),
      },
      {
        title: "مكتبة أفلام ومسلسلات NETFLIX",
        image: require("@/assets/images/movie-home/movie2.jpg"),
      },
      {
        title: "باقة قنوات SSC الرياضية السعودية",
        image: require("@/assets/images/movie-home/movie3.jpg"),
      },
      {
        title: "حصريات ومنصة SHAHID VIP",
        image: require("@/assets/images/movie-home/movie4.jpg"),
      },
      {
        title: "أحدث الأفلام والمسلسلات التركية المترجمة",
        image: require("@/assets/images/movie-home/movie5.jpg"),
      },
      {
        title: "قنوات الترفيه والأفلام OSN",
        image: require("@/assets/images/movie-home/movie6.jpg"),
      },
      {
        title: "باقة قنوات الأطفال والأنمي كاملة",
        image: require("@/assets/images/movie-home/movie1.jpg"),
      },
      {
        title: "مسلسلات رمضان والإنتاجات العربية الحصرية",
        image: require("@/assets/images/movie-home/movie2.jpg"),
      },
      {
        title: "أقوى القنوات الأوروبية والعالمية بث مباشر",
        image: require("@/assets/images/movie-home/movie3.jpg"),
      },
      {
        title: "مكتبة خاصة لأفلام الوثائقيات والعلوم",
        image: require("@/assets/images/movie-home/movie4.jpg"),
      },
    ]);

    return {
      modules: [Autoplay, Pagination],
      movies,
    };
  },
});
</script>